// Designer is an alias for the Templates form-based workflow builder.
// (Phase A: form-based editor. Phase B: full canvas drag-and-drop.)
import WAETemplates from "./WAETemplates";
export default WAETemplates;
